"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportFooter = exports.reportHeader = void 0;
const utils = require("../utils");
const DEFAULT_PATIENT_DOB = 'PATIENT DoB NOT FOUND';
// const HEADER_FOOTER_LINEHEIGHT = 1.2;
function reportHeader(meta) {
    return () => {
        var _a, _b;
        return {
            columns: [
                {
                    text: [
                        ((_a = meta === null || meta === void 0 ? void 0 : meta.orgGroupData) === null || _a === void 0 ? void 0 : _a.name) || '-',
                        '\n',
                        'Patient Summary Report',
                    ],
                    style: {
                        alignment: 'left',
                        // lineHeight: HEADER_FOOTER_LINEHEIGHT,
                    },
                    width: 'auto',
                },
                {
                    text: '',
                    width: '*',
                },
                {
                    text: [
                        utils.getUserName(meta.patientData),
                        '\n',
                        ((_b = meta.patientData) === null || _b === void 0 ? void 0 : _b.dob)
                            ? utils.dateToString(meta.patientData.dob)
                            : DEFAULT_PATIENT_DOB,
                    ],
                    style: {
                        alignment: 'right',
                        // lineHeight: HEADER_FOOTER_LINEHEIGHT,
                    },
                    width: 'auto',
                },
            ],
            style: 'patientReportHeader',
        };
    };
}
exports.reportHeader = reportHeader;
function reportFooter(meta, exportedBy, now) {
    return (currentPage, pageCount) => {
        return {
            columns: [
                {
                    text: [
                        `Export Date: ${utils.dateToString(now)}`,
                        '\n',
                        `Signed By: ${utils.getUserName(exportedBy)}`,
                    ],
                    style: {
                        alignment: 'left',
                        // lineHeight: HEADER_FOOTER_LINEHEIGHT,
                    },
                    width: 'auto',
                },
                { text: '', width: '*' },
                {
                    text: `Page ${currentPage} of ${pageCount}`,
                    style: {
                        alignment: 'center',
                    },
                    width: 'auto',
                },
                { text: '', width: '*' },
                {
                    text: [
                        utils.getPatientNumber(meta.patientData),
                        '\n',
                        'Report generated by Aetonix',
                    ],
                    style: {
                        alignment: 'right',
                        // lineHeight: HEADER_FOOTER_LINEHEIGHT,
                    },
                    width: 'auto',
                },
            ],
            style: 'patientReportFooter',
        };
    };
}
exports.reportFooter = reportFooter;
//# sourceMappingURL=layout.js.map